import api from '../api'

export const persist = async (wheels, homepageDomain, locationId, isBillTo) => {

	let hasBillToPrefs = false
	let hasUpdateCreate = false

	for (let a of wheels) {
		if (a.isBillToPreference) {
			hasBillToPrefs = true
		}
		if (a.isCreate || a.isDelete || a.isUpdate) {
			hasUpdateCreate = true
		}
	}

	let axleWheelPref

	//if hasBillToPrefs and hasUpdateCreate and !isBillTo, create and update
	if (hasBillToPrefs && hasUpdateCreate && !isBillTo) {
		//create a wheel pref id
		const axleWheelResponse = await api.service('axleWheelPreferences').create({
			name: homepageDomain.profileName, 
			fleetId: homepageDomain.homePageDomain.fleetId 
		})
		axleWheelPref = axleWheelResponse.id
		await api.service('fleetLocations').patch(locationId, {
			axleWheelPreferenceId: axleWheelPref
		})

		//loop through the wheels, save them
		for (const wheel of wheels) {
			await api.service('axleWheelDetails').create({
				preferencesId: axleWheelPref,
				wheelTypeId: wheel.wheelType,
				color: wheel.colorFinish,
				wheelMaterialId: wheel.material,
				isErs: true,
				position: 1, //TODO : position is useless for wheels right now, should probably remove at some point for ERS
				wheelWidth: 1, //TODO : width is useless for wheels right now, should probably remove at some point for ERS
				comments: wheel.comments,
				wheelOffset: wheel.offset === -1 ? null : wheel.offset,
				wheelDiameterId: wheel.diameter,
				axleTypeId: 1, //TODO : axleTypeId is useless for Wheels, need to remove at some point for ERS
			})

		}


	} else {
		for (const wheel of wheels) {

			if (wheel.isCreate) {
				if (!axleWheelPref) {
					let resp = await api.service('fleetLocations').find({
						query: {
							id: {
								$eq: locationId
							}
						}
					})
					axleWheelPref = resp.data[0].axleWheelPreferenceId
	
					if (!axleWheelPref) {
						const axleWheelResponse = await api.service('axleWheelPreferences').create({
							name: homepageDomain.profileName, 
							fleetId: homepageDomain.homePageDomain.fleetId  
						})
						axleWheelPref = axleWheelResponse.id
						await api.service('fleetLocations').patch(locationId, {
							axleWheelPreferenceId: axleWheelPref
						})
					}
				}
				await api.service('axleWheelDetails').create({
					preferencesId: axleWheelPref,
					wheelTypeId: wheel.wheelType,
					color: wheel.colorFinish,
					wheelMaterialId: wheel.material,
					isErs: true,
					position: 1,
					wheelWidth: 1,
					comments: wheel.comments,
					wheelOffset: wheel.offset === -1 ? null : wheel.offset,
					wheelDiameterId: wheel.diameter,
					axleTypeId: 1,
				})
			} else if (wheel.isDelete) {
				await api.service('axleWheelDetails').remove(null, {
					query: {
						id: {
							$eq: wheel.id
						}
					}
				})
			} else if (wheel.isUpdate) {
				await api.service('axleWheelDetails').patch(wheel.id, {
					preferenceId: axleWheelPref,
					wheelTypeId: wheel.wheelType,
					color: wheel.colorFinish,
					wheelMaterialId: wheel.material,
					isErs: true,
					position: 1,
					wheelWidth: 1,
					comments: wheel.comments,
					wheelOffset: wheel.offset === -1 ? null : wheel.offset,
					wheelDiameterId: wheel.diameter,
					axleTypeId: 1,
				})
			}
		}

	}








}


// WEBPACK FOOTER //
// ./src/database/wheelPreferences.js